import { Icon } from '@nazka/nazka.mapframe.components';

import './risk-marker.styl';

function RiskMarker({ icon, backgroundColor }) {
  return (
    <div className="risk-marker" style={{ backgroundColor }}>
      <Icon icon={icon} color="white" className="risk-marker__icon" />
    </div>
  );
}

export default RiskMarker;